import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import api from "@/lib/api";

export default function FortuneCard() {
  const { t, i18n } = useTranslation();
  const zh = !i18n.language?.startsWith("en");
  const [f, setF] = useState(null);

  useEffect(() => {
    api.get("/fortune/today").then((r) => setF(r.data)).catch(() => setF(null));
  }, []);

  return (
    <div
      className="relative overflow-hidden rounded-lg border border-[#e5ebeb] bg-white p-10 md:p-14"
      data-testid="today-fortune-card"
    >
      <div className="motif-cloud" />
      <div className="relative grid md:grid-cols-[auto,1fr] gap-10 items-start">
        <div className="text-center md:text-left">
          <div className="text-xs uppercase tracking-[0.3em] text-[#00868e] font-semibold">
            {t("fortune.title")}
          </div>
          <div className="mt-3 h-40 w-40 md:h-56 md:w-56 mx-auto md:mx-0 rounded-full border-2 border-[#00868e]/25 flex items-center justify-center relative">
            <div className="absolute inset-3 rounded-full border border-[#005870]/15" />
            <div className="text-center">
              <div className="font-serif-cn text-4xl md:text-5xl text-[#005870] font-semibold">
                {f ? (zh ? f.ganzhi_zh : f.ganzhi_en.split(" ").pop()) : "—"}
              </div>
              <div className="mt-1 text-xs text-[#4a6e77]">
                {f ? (zh ? (f.lunar_zh || f.zodiac_zh) : (f.lunar_en || f.zodiac_en)) : ""}
              </div>
            </div>
          </div>
        </div>

        <div>
          <div className="flex flex-wrap items-center gap-2 text-xs text-[#4a6e77]">
            <span className="px-3 py-1 rounded-full bg-[#e5ebeb]/60 font-medium">
              {t("fortune.zodiac")} · {f ? (zh ? f.zodiac_zh : f.zodiac_en) : "-"}
            </span>
            <span className="px-3 py-1 rounded-full bg-red-50 text-red-700 font-medium">
              {f ? (zh ? f.clash_zh : f.clash_en) : "-"}
            </span>
          </div>
          <p className="mt-6 font-serif-cn text-lg md:text-xl text-[#003645] leading-relaxed" data-testid="fortune-mood">
            {f ? (zh ? f.mood_zh : f.mood_en) : ""}
          </p>
          <div className="mt-8 grid sm:grid-cols-2 gap-6">
            <div data-testid="fortune-yi">
              <div className="text-xs uppercase tracking-widest text-[#00868e] font-semibold mb-2">
                {t("fortune.yi")}
              </div>
              <div className="flex flex-wrap gap-1.5">
                {f?.yi?.map((a, i) => (
                  <span key={i} className="px-2.5 py-1 rounded-full bg-[#00868e]/10 text-[#00868e] text-xs font-medium">
                    {zh ? a.zh : a.en}
                  </span>
                ))}
              </div>
            </div>
            <div data-testid="fortune-ji">
              <div className="text-xs uppercase tracking-widest text-red-700/80 font-semibold mb-2">
                {t("fortune.ji")}
              </div>
              <div className="flex flex-wrap gap-1.5">
                {f?.ji?.map((a, i) => (
                  <span key={i} className="px-2.5 py-1 rounded-full bg-red-50 text-red-700 text-xs font-medium">
                    {zh ? a.zh : a.en}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
